<template>
  <div class="wk-modal-form">
    <div class="item">
      <div class="title">
        <span>定向包</span>
        <span class="option" @click="handleOpenTargetedPackageDrawer"><i class="el-icon-edit-outline"></i>编辑</span>
      </div>
      <div class="form-body">
        <div class="no-data" v-if=" !(rootFormDataOptions?.app_id?.length || selectOptionData?.packageSelectData?.select?.package_names?.length)">暂无数据</div>
        <div class="list-data" v-else>
          <template v-if="isUnified">
            <div class="list-data-item" v-for="item in ( selectOptionData?.packageSelectData?.select.package_names || [] )" :key="item">
              <span class="label">{{ selectOptionData?.packageSelectData?.list[item] }}</span>
            </div>
          </template>
         <template v-else>
            <div class="list-data-item" v-for="item in rootFormDataOptions.app_id" :key="item.value">
              <span class="label">{{ item.app_name }}({{ item.show_id }})</span>
                <div class="sub-item" v-for="subItem in ( selectOptionData.packageSelectData?.select?.[item.value] || [])" :key="subItem">
                  <span class="label">{{ selectOptionData.packageSelectData.list[subItem] }}</span>
                </div>
            </div>
         </template>
        </div>
      </div>
    </div>
    <div class="item">
      <div class="title">
        <span>转化出价</span>
        <span class="option" @click="handleOpenConversionDrawer"><i class="el-icon-edit-outline"></i>编辑</span>
      </div>
      <div class="form-body">
        <div class="no-data" v-if="!creativeSize?.length">暂无数据</div>
        <div class="list-data" v-else>
          <template v-if="isPosition">
            <div class="list-data-item" v-for="item in creativeSize" :key="item.value">
              <span class="label">{{ item.label }} : {{ item.num }}</span>
            </div>
          </template>
          <template v-else>
            <div class="list-data-item" v-for="item in creativeSize" :key="item.app_id">
              <span class="label">{{ item.app_name }}({{ item.show_id }})</span>
              <div class="sub-item" v-for="subItem in item.creative_size_id" :key="subItem.value">
                <span class="label">{{ subItem.label }} : {{ subItem.num }}</span>
              </div>
            </div>
          </template>
        </div>
      </div>
    </div>
    <div class="item">
      <div class="title">
        <span>创意组</span>
        <span class="option" @click="handleOpenMaterialDrawer"><i class="el-icon-folder-opened"></i>选择素材</span>
      </div>
      <div class="form-body">
        <div class="no-data" v-if="!ideaList?.length">暂无数据</div>
        <div class="list-data" v-else>
          <div class="list-data-item" v-for="item in ideaList" :key="item.label">
            <span class="label">{{ item.app_name }}({{ item.show_id }})</span>
              <div class="sub-item" v-for="subItem in item.creative_size_id" :key="subItem.value">
                <span class="label">{{ subItem.label }} : {{ subItem.num  }}</span>
              </div>
          </div>
        </div>
        
      </div>
    </div>
    <!-- <div class="item">
      <div class="title">
        <span>广告标题</span>
        <span class="option"><i class="el-icon-circle-plus-outline"></i>添加文案</span>
      </div>
      <div class="form-body">
        <div class="no-data">暂无数据</div>
      </div>
    </div> -->
  </div>
</template>

<script>
import { materialDrawer, conversionDrawer , targetedPackageDrawer} from '../modal/index.js'
import { ADD_TYPE , ADD_PACKAGE_TYPE} from '../constant'
import { FILE_TYPE } from '../modal/materialDrawer/constant.js'
import _ from 'lodash'
export default {
    name: 'WkModalForm',
	data() {
		return {}
	},
	props: {
    rootFormDataOptions: Object,
    rootFormData: Object,
    config: Object,
    value: Array,
    formState: Object,
		openModalData: {
			type: Object,
			default: () => {
				return {}
			}
		}
	},
  computed: {
    selectOptionData() {
      const [,,, selectData] = this.value || [];
      const { conversionSelectData={}, materialSelectData={}, packageSelectData={} } = selectData || {};
      return { 
        conversionSelectData, 
        materialSelectData, 
        packageSelectData
      }
    },
    addType() {
      const { type }  = this.selectOptionData.conversionSelectData || {};
      return type || ADD_TYPE.POSITION;
    },
    addPackageType() {
      const { type }  = this.selectOptionData.packageSelectData || {};
      return type || ADD_PACKAGE_TYPE.APP;
    },
    allowEdit() {
      const appList = this.rootFormDataOptions.app_id;
      const displayTypeList = this.displayTypeList;
      return appList?.length && displayTypeList?.length;
    },
    isUnified() {
      return this.addPackageType === ADD_PACKAGE_TYPE.UNIFIED;
    },
    isPosition() {
      return this.addType === ADD_TYPE.POSITION;
    },
    displayTypeList() {
      const { creative_size_id=[] } = this.rootFormDataOptions;
      return creative_size_id.filter(item=> (this.rootFormData.creative_size_id || []).includes(item.value));
    },
    creativeSize() {
      const { app_id=[], creative_size_id=[] } = this.rootFormDataOptions;
      const selectData = this.selectOptionData.conversionSelectData?.select || {};
      if(this.isPosition) {
        return creative_size_id.filter(item=> (this.rootFormData.creative_size_id || []).includes(item.value)).map(item=> ({...item, num: selectData[item.value]?.length || 0}));
      }else {
        const creativeSize = creative_size_id.filter(item=> (this.rootFormData.creative_size_id || []).includes(item.value));
        return app_id.map(app=> {
          return {
            ...app,
            creative_size_id: creativeSize.map(item=> ({ ...item , num: selectData[`${app.value}_${item.value}`]?.length || 0}))
          }
        })
      }
     
      
    },
    ideaList() {
      const { app_id=[], creative_size_id=[] } = this.rootFormDataOptions;
      const creativeSize = creative_size_id.filter(item=> (this.rootFormData.creative_size_id || []).includes(item.value));
      const materialSelectData = this.selectOptionData.materialSelectData;
      const rule = this.rootFormData.element_group_allocation_rules
      return app_id.map(app=> {
        return {
          ...app,
          creative_size_id: creativeSize.map(item=> ({ ...item , num: this.getMaterialNum(materialSelectData[`${app.value}_${item.value}`], rule)}))
        }
      })

    }
  },
  mounted() {
    // setTimeout(() => {
    // 	this.$bus.$emit('app_id')
    // }, 1000)
  },
	methods: {
    getMaterialNum(list, type) {
    	if(!list?.length || !type) {
        return 0
      };
      if(list.includes(null)) {
        return 1;
      }
      const data = _.reduce(list, (pre, item)=> {
          const img = item[FILE_TYPE.IMAGE];
          const video = item[FILE_TYPE.VIEDO];
          if(img) {
            pre[FILE_TYPE.IMAGE].push(img);
          };
          if(video) {
            pre[FILE_TYPE.VIEDO].push(video);
          };
          return pre;
        }, { [FILE_TYPE.IMAGE]: [], [FILE_TYPE.VIEDO]: []  });
      // 按素材类型
      if( type === '1') {
        
        return _.chunk(data[FILE_TYPE.IMAGE], 10).length + _.chunk(data[FILE_TYPE.VIEDO], 5).length;
      };
      // 单素材
      if( type === '2') {
      	return data[FILE_TYPE.IMAGE].length + data[FILE_TYPE.VIEDO].length;
      };
      // 满配
      if( type === '3') {
        const chunkImgLen = _.chunk(data[FILE_TYPE.IMAGE], 10).length;
        const chunkVideoLen = _.chunk(data[FILE_TYPE.VIEDO], 5).length;
        return (chunkImgLen - chunkVideoLen) >0 ? chunkImgLen : chunkVideoLen;
      };
      return 0
    },
    handleOpenTargetedPackageDrawer() {
      if (!this.allowEdit) {
        this.$message.error('请先选择产品和版位');
        return;
      }
      const appList = this.rootFormDataOptions.app_id;
      const  [ target_list, bid_list, idea_list, defaultData ] = this.value || [];
      const onSubmit = (data, packageList, type) => {
        this.updatePackageList(data, type, packageList);
       
        vm.close()
      }
      const { vm  } = targetedPackageDrawer({
        props: {
          appList,
          config: this.config,
		      account: this.rootFormData.account_id,
          objectiveType: this.rootFormData.objective_type,
          defaultData: defaultData?.packageSelectData?.select || {},
          selectType: this.addPackageType,
        },
        cbs: { onSubmit }
      })
    },
    updatePackageList(selectList, type, packageList) {
      const {  app_id = [] } = this.rootFormData;
      const data =  _.pickBy(selectList, (list, key)=> {
        return type === ADD_PACKAGE_TYPE.UNIFIED || app_id.includes(key) ;
      });
     
      const appList = this.rootFormDataOptions.app_id;
      const  [ target_list, bid_list, idea_list, defaultData ] = this.value || [];
      const targetList = appList.reduce((pre, cur)=> {
            const list =  (type === ADD_PACKAGE_TYPE.UNIFIED? ( data.package_names || [] ) : (data[cur.value]) || []);
            const item = { 
              app_id: cur.value,
              list: list.map(item=> {
                return {
                  targeting_package_id: item,
                  targeting_package_scope: '',//留着 暂时不用
                }
              })
            };
            pre.push(item);
            return pre;
        }, []);
        this.$emit('input', [
          targetList,
          bid_list,
          idea_list, 
          { 
            ...defaultData, 
            packageSelectData: { 
              list: _.mapValues(_.keyBy(packageList, 'value'), 'label') , 
              select: data,
              type
            } }
          ]
        );
    },
    // 更新转化数据
    updateBidList(selectList, addType) {
      const { creative_size_id = [] , app_id = [] } = this.rootFormData;
      const data =  _.pickBy(selectList, (list, key)=> {
        const [ appId, sizeId ] = key.split('_');
        if(addType === ADD_TYPE.POSITION) {
          return creative_size_id.includes(appId);
        }
        return app_id.includes(appId) && creative_size_id.includes(sizeId);
      });
      console.log(data,this.value,  'datadatadatadata');
      const appList = this.rootFormDataOptions.app_id;
      const  [ target_list, bid_list, idea_list, defaultData ] = this.value || [];
        const isP = addType === ADD_TYPE.POSITION;//是否为按版位
        const bidList = appList.reduce((pre, cur)=> {
        const listMap = this.displayTypeList.map(item=> {
          const list =  (isP? data[item.value] : data[`${cur.value}_${item.value}`]) || [];
          return {
            app_id: cur.value,
            creative_size_id: item.value,
            list: list.map(item=> {
              const { way, price, strategy,deep, target,  cost, deepCost,  deepTarget, deepType } = item;
              return {
                price_type: way,
                ocpc_strategy: strategy,
                tracking_id: isP? item[cur.value] :target,
                price: price,
                conversion_cost: cost,
                deep_effect_optimize: +deep,
                deep_optimize_type: isP? item[`type_${cur.value}`] : deepType,
                deep_effect_target: isP? item[`deep_${cur.value}`] : deepTarget,
                deep_effect_price: deepCost,
              }
            })
          }
        });
        pre.push(...listMap);
        return pre;
      }, []);
      this.$emit('input', [
        target_list,
        bidList,
        idea_list,
        {...defaultData, conversionSelectData: { type: addType, select: data }} 
      ]);
    },
    handleOpenConversionDrawer() {
      if (!this.allowEdit) {
        this.$message.error('请先选择产品和版位');
        return;
      }
      const appList = this.rootFormDataOptions.app_id;
      const  [ , , , defaultData ] = this.value || [];
      const onSubmit = (data, addType) => {
        this.updateBidList(data, addType);
        vm.close()
      }
      const { vm } = conversionDrawer({
        props: {
          appList,
          displayType: this.displayTypeList,
          config: this.config,
          defaultSelectData: _.cloneDeep(defaultData?.conversionSelectData?.select || {}),
          account: this.rootFormData.account_id,
          addType: this.addType,
        },
        cbs: { onSubmit }
      })
    },
    updateMaterialList(selectList) {
      const { creative_size_id = [] , app_id = [] } = this.rootFormData;
      const data =  _.pickBy(selectList, (list, key)=> {
        const [ appId, sizeId ] = key.split('_');
        return app_id.includes(appId) && creative_size_id.includes(sizeId);
      })
      const appList = this.rootFormDataOptions.app_id;
      const  [ target_list, bid_list, idea_list, defaultData ] = this.value || [];
      const ideaList = appList.reduce((pre, cur)=> {
            const listMap = this.displayTypeList.map(item=> {
              const list = (data[`${cur.value}_${item.value}`] || []);
              return {
                app_id: cur.value,
                creative_size_id: item.value,
                ...list.reduce((pre, cur)=> {
                  if (cur === null) {
                    return pre;
                  }
                  if(cur[FILE_TYPE.VIEDO]) {
                    const { material_url, material_name } = cur[FILE_TYPE.VIEDO];
                  	pre.video_list.push({ material_url, material_name })
                  }
                  if(cur[FILE_TYPE.IMAGE]) {
                    const { material_url, material_name , config } = cur[FILE_TYPE.IMAGE];
                    const { width, height } = config || {};
                  	pre.img_list.push({ material_url, material_name, width: String(width), height: String(height) })
                  }
                  if(cur[FILE_TYPE.COVER]) {
                    const { material_url, material_name } = cur[FILE_TYPE.COVER];
                    const { width, height } = cur[FILE_TYPE.VIEDO];
                  	pre.cover_list.push({ material_url, material_name, width: String(width), height: String(height) })
                  }
                  return pre;
                }, { img_list: [], video_list: [], cover_list: [] })
              }
             
            });
            pre.push(...listMap);
            return pre;
        }, []);
        
        this.$emit('input', [
          target_list,
          bid_list,
          ideaList,
          {...defaultData, materialSelectData: data }
        ]);
    },
    handleOpenMaterialDrawer() {
      if (!this.allowEdit) {
        this.$message.error('请先选择产品和版位');
        return;
      }
      const  [ target_list, bid_list, idea_list, defaultData ] = this.value || [];
      const onSubmit = (data) => {
        this.updateMaterialList(data);
        vm.close()
      }
      const { vm } = materialDrawer({
        props: {
          appList: this.rootFormDataOptions.app_id,
          displayType: this.displayTypeList,
          config: this.config,
		      account: this.rootFormData.account_id,
          defaultData: defaultData?.materialSelectData || {},
          getMaterialNum: this.getMaterialNum,
          rule: this.rootFormData.element_group_allocation_rules,
        },
        cbs: { onSubmit }
      })
    },
    updataSelectData() {
      const  [ , , , defaultData ] = this.value || [];
      this.updateBidList(defaultData?.conversionSelectData?.select || {}, this.addType);
      this.$nextTick(()=> {
        const  [ , , , defaultData ] = this.value || [];
        const packageList = defaultData?.packageSelectData?.list || {};
        this.updatePackageList(
          defaultData?.packageSelectData?.select, 
          this.addPackageType, 
          Object.keys(packageList).map(key=> ({ value: key, label: packageList[key] }))
        );
        this.$nextTick(()=> {
          const  [,,, defaultData ] = this.value || [];
          this.updateMaterialList(defaultData?.materialSelectData || {});
        })
      })
      
    }
	},
  watch: {
    "rootFormData.creative_size_id"(n, o) {
      if(_.isEqual(n, o)) {
        return;
      }
      this.updataSelectData();
    },
  	'rootFormData.app_id'(n, o) {
      if(_.isEqual(n, o)) {
        return;
      }
      this.updataSelectData();
  	}
  }
}
</script>

<style lang="scss" scoped>
.wk-modal-form {
    display: inline-flex;
    border: 1px solid #ccc;
    height: 550px;
    .item {
        width: 360px;
        height: 100%;
        display: flex;
        flex-direction: column;
        border-right: 1px solid #ccc;
        &:last-child {
            border-right: none;
        }
        .title {
            height: 40px;
            display: flex;
            justify-content: space-between;
            align-items: center;
            border-bottom: 1px solid #ccc;
            padding: 0 20px;
            font-size: 14px;
            .option {
                color: #409EFF;
                cursor: pointer;
            }
        }
        .form-body {
            flex: 1;
            padding: 20px;
            height: 0;
            overflow: auto;
            .no-data {
                text-align: center;
                line-height: 100px;
                color: #adadad;
            }
        }
    }
    .list-data {
      &-item {
        line-height: 30px;
        .sub-item {
          padding-left: 20px;
        }
      }
    }
}
</style>